import './HeroSection.scss';

function HeroSection({
  backgroundImage,
  backgroundVideo,
  sideImage,
  sideImageAlt = 'Capoeira',
  titles,
  subtitle,
  actions,
  stats = [],
  className = '',
}) {
  const bgStyle = backgroundImage && !backgroundVideo
    ? { backgroundImage: `url(${backgroundImage})` }
    : {};

  return (
    <section className={`hero ${!backgroundImage && !backgroundVideo ? 'hero--gradient' : ''} ${className}`} style={bgStyle}>
      {backgroundVideo && (
        <video
          className="hero__video"
          autoPlay
          loop
          muted
          playsInline
          poster={backgroundImage}
        >
          <source src={backgroundVideo} type="video/mp4" />
        </video>
      )}
      <div className="hero__container">
        <div className="hero__main">
          <div className="hero__content">
            {titles.map((title, i) => (
              <h1 key={i} className="hero__title">
                {title}
              </h1>
            ))}
            {subtitle && <p className="hero__subtitle">{subtitle}</p>}
            {actions && <div className="hero__actions">{actions}</div>}
          </div>

          {sideImage && (
            <div className="hero__side-wrapper">
              <img
                src={sideImage}
                alt={sideImageAlt}
                className="hero__side-image"
              />
            </div>
          )}
        </div>

        {stats.length > 0 && (
          <div className="hero__stats">
            {stats.map((stat, i) => (
              <div key={i} className="hero__stat">
                <span className="hero__stat-value">{stat.value}</span>
                <span className="hero__stat-label">{stat.label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default HeroSection;
